import { cn } from '@/lib/utils/cn.js';
import { useFormatMoney } from './MoneyProvider.js';

interface MoneyProps {
  minor: bigint | number;
  currency?: string;
  className?: string;
}

/**
 * Renders a formatted money value.
 *
 * Splits the formatted string into integer and decimal halves so the
 * cents portion can be visually dimmed — matching the design prototype's
 * MoneyDisplay component exactly.
 *
 * `currency` omitted or equal to the LEDGER currency means a ledger figure, shown
 * in the site's display currency. Any other currency renders as-is — so to show
 * a ledger figure unconverted, use `formatMoney` directly.
 */
export function Money({ minor, currency, className }: MoneyProps) {
  const text = useFormatMoney()(minor, currency);
  const match = text.match(/^(.*?)([.,]\d+)$/);

  if (!match) {
    return <span className={cn('bf-tnum', className)}>{text}</span>;
  }

  return (
    <span className={cn('bf-tnum', className)}>
      {match[1]}
      <span style={{ color: 'var(--text-muted)', fontWeight: 500 }}>{match[2]}</span>
    </span>
  );
}
